__turbopack_context__.v({
  "curriculum-header": "curriculum-module-scss-module__lGEGKG__curriculum-header",
  "curriculum-loader": "curriculum-module-scss-module__lGEGKG__curriculum-loader",
  "curriculum-show-more": "curriculum-module-scss-module__lGEGKG__curriculum-show-more",
  "curriculum-sub-header": "curriculum-module-scss-module__lGEGKG__curriculum-sub-header",
});
